const accountsReceivable = {
  BANNER: 'Banner',
  FROZEN: 'Frozen',
  NONE: 'None',
  WARNING: 'Warning',
};

export default {
  accountsReceivable,
};
